import { alertConstants } from '../constants/actionTypes'

export const alertSuccess = (message) => ({
  type: alertConstants.ALERT_SUCCESS,
  message,
})

export const alertError = (message, errors) => ({
  type: alertConstants.ALERT_ERROR,
  message: message.replace('400', '').replace('500', ''),
  errors,
})

export const alertClear = () => ({
  type: alertConstants.ALERT_CLEAR,
})
